import React from 'react';
import { Box, BoxProps } from '@mui/material';

export const Column: React.FC<BoxProps> = (props) => (
  <Box flex='1 1 auto' mb={4} px={3} {...props} />
);
